import { _axios } from '@/plugins/axios';

const iecResource = 'api/v1/iec-requirements';

export default {
  getByFamily: family => _axios.get(`${iecResource}/all`, { params: { family } }),
};
